import { FACILITY_ROOMS } from '../../../game/phaserFacility/facilityLayout';

export const TILE_SIZE = 1;
export const ROOM_GAP = 0.1; // gap between rooms to prevent z-fighting

export const ROOM_HEIGHTS = {
  greenhouse: 1.8,
  veg: 1.2,
  flower: 1.2,
  lab: 1.4,
  curing: 1.0,
  processing: 1.2,
  marketing: 1.2,
  future: 0.05,
};

const CORRIDOR_HEIGHT = 0.3;
const CORRIDOR_Y_OFFSET = 0.05; // slight lift above ground

/**
 * Maps a room or corridor definition to Three.js world position and box dimensions.
 * Returns { x, y, z, boxW, boxH, boxD } where [x,y,z] is the mesh center.
 */
export function gridToWorld({ col, row, w, h, type }) {
  const isCorridor = !type || !ROOM_HEIGHTS[type];

  if (isCorridor) {
    return {
      x: (col + w / 2) * TILE_SIZE,
      y: CORRIDOR_Y_OFFSET + CORRIDOR_HEIGHT / 2,
      z: (row + h / 2) * TILE_SIZE,
      boxW: w * TILE_SIZE,
      boxH: CORRIDOR_HEIGHT,
      boxD: h * TILE_SIZE,
    };
  }

  const boxH = ROOM_HEIGHTS[type] || 1.2;
  return {
    x: (col + w / 2) * TILE_SIZE,
    y: boxH / 2,
    z: (row + h / 2) * TILE_SIZE,
    boxW: w * TILE_SIZE - ROOM_GAP,
    boxH: boxH,
    boxD: h * TILE_SIZE - ROOM_GAP,
  };
}

/**
 * Returns the [x, y, z] point the camera should orbit around —
 * the approximate center of the non-ghost facility footprint.
 */
export function facilityCenterTarget() {
  const nonGhost = FACILITY_ROOMS.filter(r => !r.ghost);
  let sumX = 0, sumZ = 0;
  nonGhost.forEach(r => {
    sumX += (r.col + r.w / 2) * TILE_SIZE;
    sumZ += (r.row + r.h / 2) * TILE_SIZE;
  });
  return [sumX / nonGhost.length, 0, sumZ / nonGhost.length];
}
